module.exports = __webpack_public_path__ + "static/img/4areaA_12.ae1607d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_12.png
// module id = 898
// module chunks = 1